import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';

import CustomTable from '../../../components/CustomTable';

export default function ResultList(props) {
    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            loadingPrint={props.loadingPrint}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">

                            <Tooltip placement="top" title="Ver">
                                <Button
                                    type="primary"
                                    icon="eye"
                                    size={"small"}
                                    loading={props.loadingVer}
                                    onClick={() => props.onView(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title={"Anular"}>
                                <Button
                                    disabled={row.idEstado == 1 ? false : true}
                                    type={"danger"}
                                    icon={"close"}
                                    size={"small"}
                                    onClick={() => props.onAnular(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title={"Aprobar"}>
                                <Button
                                    disabled={row.idEstado == 1 ? false : true}
                                    type={"success"}
                                    icon={"check"}
                                    size={"small"}
                                    onClick={() => props.onAprobar(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title={"Sustentar Pago"}>
                                <Button
                                    disabled={row.idEstado == 6 ? false : true}
                                    type="primary"
                                    icon="plus"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    onClick={() => props.onSustentar(row)}
                                />
                            </Tooltip>

                        </div>
                    )
                },
                {
                    title: 'Fecha Solicitud',
                    dataIndex: 'fechaSolicitud',
                    key: 'fechaSolicitud',
                    sorter: true,
                    render: (value, row) => (
                        <span>{value} {row.hora}</span>
                    )
                },

                {
                    title: 'Fecha Sustento',
                    dataIndex: 'fechaSustento',
                    key: 'fechaSustento',
                    sorter: true,
                    render: (value, row) => (
                        <span>{value} {row.horaCierre}</span>
                    )
                },
                {
                    title: 'Nro - Solicitud',
                    dataIndex: 'numero',
                    key: 'numero',
                    sorter: true
                },
                {
                    title: 'Centro de Costo',
                    dataIndex: 'centroCosto',
                    key: 'centroCosto',
                    sorter: true
                },
                {
                    title: 'Nro Documento',
                    dataIndex: 'nroDocumento',
                    key: 'nroDocumento',
                    sorter: true
                },
                {
                    title: 'Empleado',
                    dataIndex: 'empleado',
                    key: 'empleado',
                    sorter: true
                },
                {
                    title: 'Moneda',
                    dataIndex: 'moneda',
                    key: 'moneda',
                    sorter: true
                },
                {
                    title: 'Monto Solicitado',
                    dataIndex: 'montoSolicitud',
                    key: 'montoSolicitud',
                    align: 'right',
                    render: (value) => (
                        <span>{value.toFixed(2)}</span>
                    )
                },
                {
                    title: 'Monto Sustentado',
                    dataIndex: 'montoSustento',
                    key: 'montoSustento',
                    align: 'right',
                    render: (value, row) => {
                        return (<>
                            {(() => {
                                if (value > 0) {
                                    return <Tag color={"blue"}> <span>{value.toFixed(2)}</span></Tag>

                                } else {
                                    return <span>{value.toFixed(2)}</span>
                                }
                            })()}

                        </>)
                    }
                },
                {
                    title: 'Monto Devuelto a Caja',
                    dataIndex: 'montoCaja',
                    key: 'montoCaja',
                    align: 'right',
                    render: (value) => {
                        return (<>
                            {(() => {
                                if (parseFloat(value) > 0) {
                                    return <Tag color={"green"}> <span>{value.toFixed(2)}</span></Tag>

                                } else {
                                    return <span>{value.toFixed(2)}</span>
                                }
                            })()}

                        </>)
                    }
                },
                {
                    title: 'Monto Devuelto a Empleado',
                    dataIndex: 'montoEmpleado',
                    key: 'montoEmpleado',
                    align: 'right',
                    render: (value) => {
                        return (<>
                            {(() => {
                                if (parseFloat(value) > 0) {
                                    return <Tag color={"red"}> <span>{value.toFixed(2)}</span></Tag>
                                } else {
                                    return <span>{value.toFixed(2)}</span>
                                }
                            })()}

                        </>)
                    }
                },

                {
                    title: 'Monto Pendiente a Devolver',
                    dataIndex: 'montoPendiente',
                    key: 'montoPendiente',
                    align: 'right',
                    render: (value) => {
                        return (<>
                            {(() => {
                                if (parseFloat(value) > 0) {
                                    return <Tag color={"red"}> <span>{value.toFixed(2)}</span></Tag>
                                } else {
                                    return <span>{value.toFixed(2)}</span>
                                }
                            })()}

                        </>)
                    }
                },

                {
                    title: 'Estado',
                    dataIndex: 'idEstado',
                    key: 'idEstado',
                    align: 'center',
                    width: "90px",
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            {(() => {
                                switch (value) {
                                    case 1: //registado
                                        return <Tag color={"blue"}>{row.estado}</Tag>;
                                    case 2://ANULADO
                                        return <Tag color={"red"}>{row.estado}</Tag>;
                                    case 4://CERRADO
                                        return <Tag color={"red"}>{row.estado}</Tag>;
                                    case 6://APROBADO
                                        return <Tag color={"green"}>{row.estado}</Tag>;
                                    default:
                                        return null;
                                }
                            })()}

                        </div>)
                    }
                }
            ]}
        />
    );
}